module.exports = __webpack_public_path__ + "static/jan_burzynski@x2-a8c564a8add8ec036a4d68f9a93fe7f6.jpg";